export const preAccountListData = {
  data: [
    {
      Id: '5aee7c1d-b9fd-4c1d-8073-cabd1b0e8bcd',
      Identity: {
        FirstName: 'Alice',
        LastName: 'Smith',
        Email: 'alice.smith@example.com'
      },
      PreOnboardingUrl: 'https://example.com/pre-onboarding/12345',
      Type: 'INDIVIDUAL',
      CreatedAt: '2025-09-22T13:26:13.766Z'
    },
    {
      Id: '5aee7c1d-b9fd-4c1d-8073-cabd1b0e8bcd',
      Identity: {
        Name: 'Asian Junction Inc'
      },
      PreOnboardingUrl: 'https://example.com/pre-onboarding/67890',
      Type: 'LEGAL_ENTITY',
      CreatedAt: '2025-09-22T13:26:13.766Z'
    }
  ]
};
